


































































import FormDataSubmit from '~/mixins/form-data-submit'

export default

	mixins: [
		FormDataSubmit
	]

	props:
		block:
			type: Object
			default: -> {
				title: null
				fields: []
			}

		step: Number

		# Generic "Please fix your errors" message defined in home.yml
		errorMessages: Object

		consentToProcessMessage: String

	data: ->
		# On mount, we grab a cloned snapshot of @formData (from VueX store)
		# and save it to our component data.
		# We do this becuase we care only about the initial value, and we don't want
		# our field's props to reactively change, which could cause unwanted side effects and re-rendering.
		formDataOnMount: {}

	computed:
		layout: -> @$store.state.globals.layout
		steps: -> @layout?.nav?.steps || []
		currentStep: -> @$store.state.globals.currentStep
		formData: -> @$store.state.globals.data
		formId: -> "step-#{@step}"
		bottomLine: -> @block?.bottomLine || {}
		results: -> @$store.getters['globals/results']
		dataConfig: -> @$store.state.globals.dataConfig
		isFirstStep: -> @step == 0
		isActiveStep: -> @step == @currentStep

		# Are we the last step before the results
		isLastStep: -> @step == @steps.length - 2

		bottomLineValue: ->
			return '' unless @bottomLine.resultsProperty
			value = @results?[@bottomLine.resultsProperty]

			# If it can't be parsed to a number, return the original string
			return value if isNaN parseFloat(value)

			# Parse it to a number, then add nice commas
			result = parseFloat value
			return result unless result?.toLocaleString?
			result.toLocaleString( window?.navigator?.language || 'en-US' )

		showBtn: ->
			# If this is the last step, always show the button
			# so that we can jump to the results page.
			return true if @isLastStep

			# Else, show the button if the next step is still hidden.
			return @isActiveStep

		inittedFormDataFromUrl: -> @$store.state.globals.appState.inittedFormDataFromUrl

		haveEngineerQty: -> @formData.engineerQty and @formData.engineerQty != '0'
		haveContractorQty: -> @formData.contractorQty and @formData.contractorQty != '0'

		consentToProcess: -> !!@formData.consentToProcess

	methods:

		# Get vue-form field component from field.type
		getFieldComponent: (field) ->
			switch field.type
				when 'input' then 'input-field'
				when 'number' then 'number-field'
				when 'checkbox' then 'checkbox-field'
				when 'select' then 'select-field'
				when 'radio' then 'radio-field'
				when 'slider' then 'slider-field'

		getFieldProps: (itemArg) ->
			# Clone so we don't modify our component props
			item = { ...itemArg }
			# Delete properties that should not be passed as props
			delete item.tooltip
			delete item.tooltipTitle
			delete item.defaultButton
			delete item.pii

			# For the field's initial value on mount, use the initial formData if it exists.
			# This was set by reading the URL params.
			defaultVal = @formDataOnMount[item.name]

			# Else, fallback to the default specified in 'step-*.yml', if it exists.
			defaultVal ?= String item.default if item.default?

			# Engineer Salary
			if item.name == 'engineerSalary'
				# If we don't have engineers, then make the default salary 0.
				item.placeholder = '0' unless @haveEngineerQty

			# Contractor Salary
			if item.name == 'contractorSalary'
				# If we don't have contractors, then make the default salary 0.
				item.placeholder = '0' unless @haveContractorQty

			return {
				...item
				default: defaultVal
			}

		saveFormDataSnapshot: ->
			# Grab a cloned snapshot of @formData (from VueX store)
			# and save it to our component data.
			@formDataOnMount = { ...@formData }

		# Sync updated field data to the store
		formUpdated: (data) ->
			progress = @$refs.form?.validRatio || 0
			@$store.commit('globals/setData', data)
			@$store.commit('globals/setProgress', {step: "step#{@step}", progress: progress})

		# Get the user-facing error message
		getSubmitErrorMessage: ({ hasErrorsShown, error }) ->

			# If this step is showing validation errors
			return @errorMessages?.invalidFields if hasErrorsShown

			# If one of the previous steps has a validation error
			return @errorMessages?.invalidFields if error == 'INVALID_STEP'

			# If Hubspot says the user's email address is invalid
			return @errorMessages?.INVALID_EMAIL if error == 'INVALID_EMAIL'

			# If the user doesn't have at least one engineer
			return @errorMessages?.NOT_ENOUGH_ENGINEERS if error == 'NOT_ENOUGH_ENGINEERS'

			# If we have an unexpected error, show a generic message.
			return @errorMessages?.generic if error

			# No error
			return ''

		# Should the submit button be disabled
		getSubmitDisabledState: ({ hasErrorsShown, error }) ->
			return true if hasErrorsShown
			false

		# Get the value for a field's "use default" button
		getDefaultValue: (name, defaultValue) ->
			# Engineer salary: if we don't have contractors, make the default 0.
			return '0' if name == 'engineerSalary' and !@haveEngineerQty

			# Contractor salary: if we don't have contractors, make the default 0.
			return '0' if name == 'contractorSalary' and !@haveContractorQty

			# Else, use the default value.
			return defaultValue

	watch:
		# When we've finished initting our store from our URL params,
		# grab a snapshot of the store's initial value so we can set the
		# initial values of our fields.
		inittedFormDataFromUrl:
			immediate: true
			handler: ->
				if @inittedFormDataFromUrl
					@saveFormDataSnapshot()

